/**
 * Use this file to all in scripts and functions you would like to have globally or on specific
 * pages. You will use this to extend your theme instead of adding code to the core framework files.
 */

function _defineProperties(target, props) {
	for (var i = 0; i < props.length; i++) {
		var descriptor = props[i];
		descriptor.enumerable = descriptor.enumerable || false;
		descriptor.configurable = true;
		if ("value" in descriptor) descriptor.writable = true;
		Object.defineProperty(target, descriptor.key, descriptor);
	}
}

function _createClass(Constructor, protoProps, staticProps) {
	if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	if (staticProps) _defineProperties(Constructor, staticProps);
	return Constructor;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError('Cannot call a class as a function');
	}
}

var themeFunctionality = {
	init: function () {
		themeFunctionality.pageID = document.body.id.toCamelCase();

		/**
		 * Remove preload class
		 */
		// if ($('html').hasClass('t-preload')) {
		// 	$('html').removeClass('t-preload');
		// }

		// Build Query Object and Array
		// (function() {
		// 	var buildQueryObjects = window.buildQueryObjects = function() {
		// 		var queryString = window.location.search.slice(1);
		// 		var queryArray = [];
		// 		var query = {};

		// 		if (queryString) {
		// 			queryArray = queryString.split('&').map(function(item) {
		// 				var pair = item.split('=');
		// 				var name = decodeURIComponent(pair.shift());
		// 				var value = decodeURIComponent(pair.join('='));

		// 				// set query object properties
		// 				query[name] = query[name] || [];
		// 				query[name].push(value);

		// 				// return array item
		// 				return { name: name, value: value };
		// 			});
		// 		}

		// 		return { object: query, array: queryArray };
		// 	};

		// 	var query = buildQueryObjects();
		// 	window.queryArray = query.array;
		// 	window.query = query.object;
		// })();

		/**
		 * Create MediaQueryList using breakpoint name
		 * @param {string} breakpointName
		 * @return {MediaQueryList|null}
		 */
		(function() {
			var breakpointSizes = {
				small: 40,
				medium: 48,
				large: 60,
				widescreen: 90,
			};

			window.mediaQueryListFactory = function mediaQueryListFactory(breakpointName) {;
				if (!breakpointName || !window.matchMedia) {
					return null;
				}

				var breakpoint = breakpointSizes[breakpointName];
				var mediaQuery = '(min-width: ' + breakpoint + 'em)';
				return window.matchMedia(mediaQuery);
			};

			themeFunctionality.mediaQueryLists = {
				small: mediaQueryListFactory('small'),
				medium: mediaQueryListFactory('medium'),
				large: mediaQueryListFactory('large'),
				widescreen: mediaQueryListFactory('widescreen'),
			};
		})();

		/**
		 * Load SVG Injector
		 */
		// var injectableSVGs = document.querySelectorAll('svg[data-src]');
		// if (injectableSVGs.length) {
		// 	$.loadScript(theme_path + 'extensions/svg-injector/svg-injector.min.js', function() {
		// 		SVGInjector(injectableSVGs);
		// 	});
		// }

		/**
		 * Load and initialize AOS
		*/
		// $.loadScript(theme_path + 'extensions/aos/aos.min.js', function () {
			// ---- Initialize AOS ---- //
			// AOS.init({
			// 	disable: 'mobile'
			// });
		// });

		/**
		 * Mini-Modal Close Button (custom)
		 */
		// $('body').on('click', '.c-mini-modal__close-custom', function(e){
		// 	if ($(document).find('.c-mini-modal__close').length) {
		// 		$(document).find('.c-mini-modal__close').trigger('click');
		// 	} else {
		// 		window.parent.$('.c-mini-modal__close').trigger('click');
		// 	}
		// });

		/**
		 * Load and initialize the Fasten Header extension
		 */
		// $.loadScript(theme_path + 'extensions/fasten-header/fasten-header.min.js');
		var $sticky = $.hook("sticky-target");
		if ($sticky.length) {
			import('extensions/sticky/jquery.sticky-kit.min').then(function () {
				$sticky.each(function(i, sticky) {
					var options = $(sticky).data('options');
					var $this = $(sticky);

					switch(themeFunctionality.pageID) {
						case 'jsPROD': {
							var widescreenList = themeFunctionality.mediaQueryLists.widescreen;
							function onWidescreenMatch(event) {
								if (event.matches) {
									$this.stick_in_parent(options);
								} else {
									$this.trigger('sticky_kit:detach');
								}
							}

							onWidescreenMatch(widescreenList);
							widescreenList.addListener(onWidescreenMatch);

							break;
						}
						case 'js-CTGY_QUESTION_BUILDER': {
							$this.trigger('sticky_kit:detach');
							break;
						}

						default: {
							$(sticky).stick_in_parent(options);
						}
					}
				});
			});
		}

		// if ($('.lazyload').length) {
		// 	$.loadScript(theme_path + 'extensions/lazysizes/plugins/blur-up/ls.blur-up.min.js');
		// 	$.loadScript(theme_path + 'extensions/lazysizes/plugins/parent-fit/ls.parent-fit.min.js');
		// 	$.loadScript(theme_path + 'extensions/lazysizes/plugins/object-fit/ls.object-fit.min.js');
		// 	$.loadScript(theme_path + 'extensions/lazysizes/plugins/unveilhooks/ls.unveilhooks.min.js');
		// 	// $.loadScript(theme_path + 'extensions/lazysizes/plugins/progressive/ls.progressive.min.js');
		// 	$.loadScript(theme_path + 'extensions/lazysizes/lazysizes.min.js', function() {
		// 		window.lazySizesConfig = window.lazySizesConfig || {};
		// 		window.lazySizesConfig.loadMode = 1;
		// 	});
		// }

		// var $starRating = $('[data-rating]');
		// if ($starRating.length) {
		// 	$.loadScript(theme_path + 'extensions/star-rating-svg/jquery.star-rating-svg.min.js', function() {
		// 		$starRating.each(function(i, rating) {
		// 			var $rating = $(rating);
		// 			$rating.starRating($rating.data('rating'));
		// 		});
		// 	});
		// }

		// TODO add to bundle
		var $slick = $('[data-slick]');
		var $otherSlick = $.hook('x-product-layout-images__image-carousel')
			.add($.hook('x-product-layout-images__thumbnail-list'))
			.add($.hook('product-carousel'));

		if ($slick.length || $otherSlick.length) {
			themeFunctionality.slickLoading = true;
			import('extensions/slick/slick').then(function() {
				$(window).trigger('slickLoaded');

				if (!$slick.length) return;

				if (typeof document.documentElement.style.objectFit === 'undefined') {
					$('.testimonials-slide').each(function() {
						var $container = $(this).find('.image-wrap');
						var imgUrl = $container.find('img').data('lazy');

						if (imgUrl) {
							$container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('compat-object-fit');
						}
					});
				}

				$slick.each(function(i, slider) {
					var $slider = $(slider);
					var config = $slider.data('slick');
					if ($slider.children().length <= config.slidesToShow) config.dots = false;
					if (config.responsive && config.responsive.length) {
						config.responsive = config.responsive.map(function(item) {
							if (item.settings.slidesToShow && $slider.children().length <= item.settings.slidesToShow) item.settings.dots = false;

							return item;
						});
					}

					$slider.slick(config);
				});
			});
		}

		/**
		 * Load and initialize magnificPopup
		 */
		// $.loadScript(theme_path + 'extensions/magnificpopup/jquery.magnific-popup.min.js', function() {
		// 	if (!$.hook('x-magnific-popup').length && !$.hook('x-magnific-popup__ajax').length) return;

		// 	$.hook('x-magnific-popup').magnificPopup();
		// 	$.hook('x-magnific-popup__ajax').magnificPopup({ type: 'ajax' });
		// });


		/**
		 * Toggle the `is-open` state of dropdown boxes.
		 */
		// (function () {
		// 	var triggers = Array.from(document.querySelectorAll('[data-hook="show-related"]'));
		// 	var allRelatedTargets = [];

		// 	if (triggers && triggers.length) {
		// 		triggers.forEach(function(trigger) {
		// 			var relatedTargets = document.querySelectorAll('[data-hook="' + trigger.getAttribute('data-target') + '"]');
		// 			allRelatedTargets.push.apply(allRelatedTargets, relatedTargets);

		// 			trigger.addEventListener('click', function (event) {
		// 				event.preventDefault();

		// 				relatedTargets.forEach(function(relatedTarget) {
		// 					relatedTarget.classList.toggle('is-open');

		// 					if (event.currentTarget.getAttribute('data-target') === 'quick-search') {
		// 						var searchField = relatedTarget.querySelector('input[type="search"]');
		// 						if (searchField) searchField.focus();
		// 					}
		// 				});
		// 			}, false);
		// 		});

		// 		allRelatedTargets = allRelatedTargets.filter(function(value, index, self) { return self.indexOf(value) === index; });

		// 		document.addEventListener('click', function (event) {
		// 			allRelatedTargets.forEach(function(relatedTarget) {
		// 				if (relatedTarget.classList.contains('is-open')) {
		// 					if (!relatedTarget.contains(event.target) && triggers.every(function(trigger) { return !trigger.contains(event.target) && trigger !== event.target; })) {
		// 						relatedTarget.classList.toggle('is-open');
		// 						event.preventDefault();
		// 					}
		// 				}
		// 			});
		// 		}, false);

		// 		window.addEventListener('keydown', function (event) {
		// 			if (event.defaultPrevented) {
		// 				return;
		// 			}

		// 			switch (event.key) {
		// 				case 'Escape':
		// 					relatedTargets.forEach(function(relatedTarget) {
		// 						if (relatedTarget.classList.contains('is-open')) {
		// 							relatedTarget.classList.toggle('is-open');
		// 						}
		// 					});
		// 					break;
		// 				default:
		// 					return;
		// 			}

		// 			event.preventDefault();
		// 		}, true);
		// 	}
		// })();

		/**
		 * Toggle Button Filters
		 */
		// (function () {
		// 	var ToggleButtonGroup = function () {
		// 		"use strict";

		// 		function ToggleButtonGroup(buttonGroup) {
		// 			this.$buttonGroup = $(buttonGroup);
		// 			this.$input = $("input[name=\"" + buttonGroup.dataset.toggleButtons + "\"]", this.$buttonGroup);
		// 			this.$buttons = $('button[data-filter-by]', this.$buttonGroup);
		// 			this.onInputChange = this.onInputChange.bind(this);
		// 			this.onButtonClick = this.onButtonClick.bind(this);
		// 			this.init();
		// 		}

		// 		var _proto = ToggleButtonGroup.prototype;

		// 		_proto.init = function init() {
		// 			this.update();
		// 			this.bindEvents();
		// 		};

		// 		_proto.bindEvents = function bindEvents() {
		// 			this.$buttonGroup.on('change', 'input', this.onInputChange);
		// 			this.$buttonGroup.on('click', 'button', this.onButtonClick);
		// 			$(document).on('updateToggleButtonInstances', this.onInputChange);
		// 		};

		// 		_proto.onInputChange = function onInputChange(event) {
		// 			this.update();
		// 		};

		// 		_proto.onButtonClick = function onButtonClick(event) {
		// 			var target = event.currentTarget;
		// 			var unique = target.hasAttribute('data-filter-unique');
		// 			var filterBy = target.dataset.filterBy;
		// 			var values = this.$input.prop('values');
		// 			if (unique) values = [];

		// 			if (filterBy) {
		// 				var existing = values.indexOf(filterBy);
		// 				if (existing > -1) values.splice(existing, 1);else values.push(filterBy);
		// 			}

		// 			this.$input.val(values.join(', '));
		// 			this.$input.trigger('change');
		// 		};

		// 		_proto.update = function update() {
		// 			this.$input.prop('values', this.getInputValue());
		// 			this.updateButtonStates();
		// 		};

		// 		_proto.getInputValue = function getInputValue() {
		// 			var value = this.$input.val();
		// 			return value && value.split(', ') || [];
		// 		};

		// 		_proto.updateButtonStates = function updateButtonStates() {
		// 			var values = this.$input.prop('values');
		// 			this.$buttons.each(function (i, button) {
		// 				var $button = $(button);
		// 				var filterBy = button.dataset.filterBy;
		// 				var allButton = filterBy === '';
		// 				var existing = values.indexOf(filterBy) !== -1;
		// 				$button.toggleClass('checked is-active', existing || allButton && !values.length);
		// 			});
		// 		};

		// 		return ToggleButtonGroup;
		// 	}();

		// 	$('[data-toggle-buttons]').each(function (i, item) {
		// 		var buttonGroupInstance = new ToggleButtonGroup(item);
		// 	});
		// })();

		/* Custom Close Button for Modal Windows */
		$('body').on('click', '.c-mini-modal__cclose', function(e){
			$('body').find('.c-mini-modal__close').trigger('click');
		});

		if ( $('body').hasClass('t-page-quickview') ) {
			console.log('quickview');
		} else {
			/**
			 * Load and initialize the Mini-Basket extension
			 */
			import('extensions/mini-basket--custom/mini-basket').then(function ({miniBasket}) {
				miniBasket.init();
			});

			/**
			 * Load and initialize the Collapsing Breadcrumbs extension
			 */
			// import('extensions/breadcrumbs/collapsing-breadcrumbs');
		}

		/* Lazy Loading */
		// $.loadScript(theme_path + 'extensions/lazyload/jquery.lazyload-any.min.js', function () {
		// 	$.hook('x-lazyload-element').lazyload({
		// 		// Sets the pixels to load earlier. Setting threshold to 200 causes image to load 200 pixels
		// 		// before it appears on viewport. It should be greater or equal zero.
		// 		threshold: 200,

		// 		// Sets the callback function when the load event is firing.
		// 		// element: The content in lazyload tag will be returned as a jQuery object.
		// 		load: function(element) {
		// 			element.addClass('x-lazyload-element__loaded');
		// 		},

		// 		// Sets events to trigger lazyload. Default is customized event `appear`, it will trigger when
		// 		// element appear in screen. You could set other events including each one separated by a space.
		// 		trigger: "appear"
		// 	});
		// });


	},
	sharedFunctions: {
		initVimeoPlayer: async function () {
			const Player = await import('@vimeo/player');;

			/**
			 * @param  {String} func Name of the callback function
			 * @param  {Object} minimodal Class instance of the mini modal
			 */
			return async function (func, minimodal) {
				const minimodalElement = minimodal.content.querySelector('.c-mini-modal__element');
				const minimodalVideoElement = minimodalElement.querySelector('.c-mini-modal__video');
				const mediaID = minimodal.current.getAttribute('data-media-id');

				if (mediaID.trim().length === 0) {
					return;
				}

				// Media player styling
				minimodalElement.classList.add('c-mini-modal__element--video');

				/*
				 * Create a new instance of a video player. We cannot use the same player instance as
				 * the mini-modal will remove all the content from the DOM tree. Creating multiple player
				 * instances does cause us to request `player.js` and `player.css` multiple times. The browser
				 * will cache these resources.
				*/
				const mediaPlayer = new Player.default(minimodalVideoElement, {
					height: minimodalElement.offsetHeight,
					id: mediaID,
					width: minimodalElement.offsetWidth
				});

				// Add media player styling and play video when the `iframe` is initialized
				await mediaPlayer.ready();
				mediaPlayer.element.classList.add('c-mini-modal__video');

				await mediaPlayer.setVolume(0.5);
				await mediaPlayer.play();
			}
		},
		createCookie: function(c, d, a) {
			if (a) {
				var b = new Date;
				b.setTime(b.getTime() + 864E5 * a);
				a = "; expires=" + b.toGMTString()
			} else a = "";
			document.cookie = c + "=" + d + a + "; path=/"
		},
		readCookie: function(b) {
			for (var b = b + "=", d = document.cookie.split(";"), c = 0; c < d.length; c++) {
				for (var a = d[c];
					" " == a.charAt(0);) a = a.substring(1, a.length);
				if (0 == a.indexOf(b)) return a.substring(b.length, a.length)
			}
			return null
		},
		eraseCookie: function(a) {
			createCookie(a, "", -1)
		},
		xToggleDrawer: function() {

			/**
			 * Drawer toggling
			 */
			// define helper vars
			var $handles = $.hook('x_toggle_handle');
			var $drawers = $.hook('x_toggle_drawer');

			// assign index number dynamically to handle ( corresponds to a matching drawer by index )
			var assignIndex = function(index, element) {

				var $element = $(element);
				$element.attr('data-index', index);

			};
			$handles.each(assignIndex);

			// bind events
			$handles.on('click', function() {

				var $handle = $(this);
				var index = $handle.data('index');

				var $handleText = $handle.find('[data-hook~="x_toggle_handle_text"]');
				var shownText = $handleText.data('shown');
				var hiddenText = $handleText.data('hidden');

				// get drawer by index
				var $drawer = $($drawers.get(index));

				// if drawer was found
				if ($drawer.length == 1) {

					// handle text set
					if (!$drawer.is(':visible')) {
						$handleText.text(shownText);
					} else {
						$handleText.text(hiddenText);
					}

					// toggle drawer display
					$drawer.toggle();

				}

			});

		},
		initProductModal: function(container) {

			if ($.fn.magnificPopup == undefined) {
				import('extensions/magnificpopup/jquery.magnific-popup').then(function() {
					themeFunctionality.sharedFunctions.initProductModal('x-product-layout-images__anchor');
				});
			} else {
				$.magnificPopup.instance.popupsCache = {};

				$.hook(container).magnificPopup({
					gallery: {
						enabled: true
					},
					type: 'image'
				});
			}

		},
		initMiniModals: function() {
			var targets = document.querySelectorAll('[data-mini-modal]');
			for (var i = 0; i < targets.length; i += 1) {
				var modal = minimodal(targets[i], {
					// options
					statusTimeout: 600,
					removeTimeout: 600,
					closeTimeout: 600
				});
				modal.init();
			}
		},
		productShareButtons: function() {

			function PopupCenter(url, title, w, h) {
				// Fixes dual-screen position                         Most browsers      Firefox
				var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
				var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

				var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
				var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

				var left = ((width / 2) - (w / 2)) + dualScreenLeft;
				var top = ((height / 2) - (h / 2)) + dualScreenTop;
				var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

				// Puts focus on the newWindow
				if (window.focus) {
					newWindow.focus();
				}
			}

			$.hook('x-social-sharing--cell__link').on('click', function(e) {
				e.preventDefault();

				console.log('social - click');

				var $this = $(this);
				var social_media_type = $this.attr('data-social');
				var url = '';

				switch (social_media_type) {
					case 'facebook':
						url = $this.attr('href');
						url += '&u=' + $this.attr('data-u');
						PopupCenter(url, 'Share', 750, 650);
						break;
					case 'twitter':
						url = $this.attr('href');
						PopupCenter(url, 'Share', 500, 300);
						break;
					case 'pinterest':
						url = $this.attr('href');
						url += '?url=' + $this.attr('data-url');
						url += '&media=' + $this.attr('data-media');
						url += '&description=' + $this.attr('data-description');
						PopupCenter(url, 'Share', 750, 650);
						break;
				}

				return false;
			});

		},
		redeemCoupon: function() {
			var checkout_basket_summary_selector = '#checkout_basket_summary';
			$.hook('basket_coupon-form').on('submit', function(e) {

				e.preventDefault();
				var $form = $(this),
					$button = $form.find('.c-button');

				// Throttle Submits
				if ($button.prop('disabled')) return;
				$button.prop('disabled', true).data('orig-val', $button.val()).val('Processing...');
				$form.find('#messages').remove();

				// AJAX Redeem Coupon
				$.ajax({
						url: $form.prop('action'),
						type: $form.prop('method'),
						data: $form.serialize()
					})
					.done(function(response) {
						console.log(response);
						var $response = $(response),
							$checkout_basket_summary = $(checkout_basket_summary_selector),
							$response_messages = $response.find('#messages');

						$checkout_basket_summary.replaceWith($response.find(checkout_basket_summary_selector));

						if ($response_messages.find('.x-messages--error').length) {
							$form.append($response_messages);
						}
					})
					.always(function() {
						$button.val($button.data('orig-val')).prop('disabled', false);
					});
			});
		},
		redeemGiftCertificate: function() {
			var checkout_basket_summary_selector = '#checkout_basket_summary';
			$.hook('gift_certificate-form').on('submit', function(e) {

				e.preventDefault();
				var $form = $(this),
					$button = $form.find('.c-button');

				// Throttle Submits
				if ($button.prop('disabled')) return;
				$button.prop('disabled', true).data('orig-val', $button.val()).val('Processing...');
				$form.find('#messages').remove();

				// AJAX Redeem Coupon
				$.ajax({
						url: $form.prop('action'),
						type: $form.prop('method'),
						data: $form.serialize()
					})
					.done(function(response) {
						console.log(response);
						/*            var $response = $(response),
														$checkout_basket_summary = $response.find(checkout_basket_summary_selector),
														$response_messages = $response.find('#messages');

												$checkout_basket_summary.replaceWith($response.find(checkout_basket_summary_selector));

												if( $response_messages.find('.x-messages--error').length ){
														$form.append($response_messages);
												}*/
					})
					.always(function() {
						$button.val($button.data('orig-val')).prop('disabled', false);
					});
			});
		},
		xVariantKitPriceChange: function(product_data) {

			$.ajax({
					url: mivaJS.Miva_AJAX_URL,
					data: {
						Verb: 'Get_Variant_Kit_Price_SOP',
						Variant_ID: product_data.variant_id,
						Product_Code: product_data.product_code
					}
				})
				.done(function(response) {

					if (response && response.success) {

						$.hook('kit-price').text(response.data.kitPrice);

					} else {

						$.hook('kit-price').text(response.message);

					}

				});

		}
	},
	productFunctions: {
		initializeSlickSlider: function(container, options) {
			if (container.hasClass('slick-initialized')) {
				container.slick('unslick');
			}

			if ($.fn.slick == undefined) {
				import('extensions/slick/slick').then(function() {
					container.slick(options);
				});
			} else {
				container.slick(options);
			}
		}
	},
	jsSFNT: function() {},
	jsCTGY: function(pageID) {
		/**
		 * Load and initialize the Components extension
		 */
		// $.loadScript(theme_path + 'extensions/components_and_layouts--custom/components.min.js');
	},
	jsCTGY_DESIGNER: function () {
		this.jsCTGY_TOP_DESIGNER();
	},
	jsCTGY_TOP_DESIGNER: async function () {
		const mivaJS = window.mivaJS || {};

		// Mini Modal open callback function
		mivaJS.loadVimeoPlayer = await this.sharedFunctions.initVimeoPlayer();
	},
	jsCTGY_TOP: function() {
		/**
		 * Load and initialize the Components extension
		 */
		// $.loadScript(theme_path + 'extensions/components_and_layouts--custom/components.min.js');

		// Tabs
		// $.loadScript(theme_path + 'extensions/responsive-tabs--custom/jquery.responsiveTabs.min.js', function() {
		// 	$.hook('c-ctgy-tabs').responsiveTabs({
		// 		navigationContainer: '.c-ctgy--tabs__header'
		// 	});
		// });

		// Swiper Slider
		$.hook('shop-by-size').on('click', function(e) {
			$.hook('x-flex-slider__visible').each(function(i, elem) {
				if (elem.slick) {
					elem.slick.orientationChange();
					elem.slick.slickUnfilter();
				}
			});
		});

		// Show More Toggles
		$.hook('x-subcat-list__loadsizes').on('click', function(event){
			$('.c-ctgy--tabs__content___hidden').toggleClass('u-hidden');

			$(event.currentTarget).toggleClass('active');

			if ( $(event.currentTarget).find('.c-button--seemore---label').text().trim() == 'See More Sizes') {
				$(event.currentTarget).find('.c-button--seemore---label').text('See Less Sizes');
			} else {
				$(event.currentTarget).find('.c-button--seemore---label').text('See More Sizes');
			}

			$.hook('x-flex-slider__invisible').each(function(i, elem) {
				if (elem.slick) {
					elem.slick.orientationChange();
					elem.slick.slickUnfilter();
				}
			});
		});

		// $.hook('x-subcat-list__load').on('click', function(event){
		// 	$('.x-product-list__item___hide').toggleClass('u-hidden');

		// 	$(event.currentTarget).toggleClass('active');

		// 	if ( $(event.currentTarget).find('.c-button--seemore---label').text().trim() == 'See More Shapes') {
		// 		$(event.currentTarget).find('.c-button--seemore---label').text('See Less Shapes');
		// 	} else {
		// 		$(event.currentTarget).find('.c-button--seemore---label').text('See More Shapes');
		// 	}
		// });
	},
	jsCTGY_VISUAL: function() {
		/**
		 * Load and initialize the Components extension
		 */
		// $.loadScript(theme_path + 'extensions/components_and_layouts--custom/components.min.js');

		/**
		 * Load and initialize the visual facets extension
		 */
		// $.loadScript(theme_path + 'extensions/visual-facets/visual_facets.min.js');

		/**
		 * Load Tabs for mobile only
		 */
		// var visualFacetsTabs = function(){
		// 	if ( window.innerWidth < 960 ) {
		// 		$.loadScript(theme_path + 'extensions/responsive-tabs--custom/jquery.responsiveTabs.min.js', function() {
		// 			$.hook('x-visual-facets').responsiveTabs({
		// 				navigationContainer: '.x-visual-facets-tabs__header'
		// 			});
		// 		});
		// 	}
		// };
		// visualFacetsTabs();

		// $(window).on('resize', function () {
		// 	visualFacetsTabs();
		// });

	},
	jsCTGY_MODEL: function() {
		// Model Category Specific Javascript
		// (function() {

		// })();
	},
	jsCTGY_QSTN: function() {
		// Collapsible Lists
		// (function() {
		// 	if ($('[data-collapsible-list]').length) {
		// 		$('[data-collapsible-list] + .card-list-action [data-view-more]').on('click', function(event) {
		// 			var $button = $(event.currentTarget);
		// 			var $buttonText = $('span', $button);
		// 			var $buttonSvg = $('svg use', $button);
		// 			var $list = $button.parents('.card-list-action').prev('[data-collapsible-list]');

		// 			$list.slideToggle(function(e) {
		// 				var visible = $list.is(':visible');
		// 				var icon = visible ? '#icon-minus': '#icon-plus';

		// 				$buttonText.text(visible ? 'View Less' : 'View More');
		// 				$buttonSvg.attr({ 'xlink:href': icon, href: icon });
		// 			});
		// 		});
		// 	}
		// })();
	},
	jsCTGY_SIZE: function() {
		/**
		 * Load and initialize the Components extension
		 */
		// $.loadScript(theme_path + 'extensions/components_and_layouts--custom/components.min.js');

		// $.hook('x-display-list-facet__toggle').on('click', function(e){
		// 	$('body').toggleClass('x-facet-header--is-active');

		// 	if ( $(this).text().trim() == 'Hide Filters') {
		// 		$(this).find('.x-display-list-facet__toggle___label').text('Show Filters');
		// 	} else {
		// 		$(this).find('.x-display-list-facet__toggle___label').text('Hide Filters');
		// 	}
		// });

		// // Show More Toggles
		// $.hook('x-subcategory-list__loadsizes').on('click', function(e){
		// 	$('.x-subcategory-list__inactive').toggleClass('u-hidden');

		// 	$(this).toggleClass('active');

		// 	if ( $(this).find('.c-button--seemore---label').text().trim() == 'See More Sizes') {
		// 		$(this).find('.c-button--seemore---label').text('See Less Sizes');
		// 	} else {
		// 		$(this).find('.c-button--seemore---label').text('See More Sizes');
		// 	}
		// });
	},
	jsPROD: function() {

		var $windowWidth = $(window).width(),
			thumbnailLength = 5;

		/**
		 * Buy Together
		 */
		if ($('.x-buytogether-wrapper').length) {
			import('extensions/buytogether/buytogether');
		}

		$('body').on('change', '.x-buytogether-list__input', function() {
			var totals = 0,
				total_qty = 0;

			$('.x-buytogether-list__input').each(function() {
				var checked = $(this).is(':checked');
				console.log('Checked', checked);
				if (checked) {
					var price = $(this).data('prodprice');
					totals += parseFloat(price);
					total_qty++;

					console.log(parseFloat(price));
				}
			});

			$('body').find('.x-buytogether-list__total').text('$' + totals.toFixed(2));
			$('body').find('.x-buytogether-list__qty').text(total_qty);

			console.log('total', totals, 'qty', total_qty);
		});

		/**
		 * Load and initialize the Quantify extension
		 */
		import('extensions/quantify/quantify');

		/**
		 * Load and initialize the Tabs extension
		 */
		import('extensions/tabs/tabs');

		/**
		 * Load and initialize the Sticky extension
		 */
		// $.loadScript(theme_path + 'extensions/sticky/jquery.sticky-kit.min.js', function () {
		//     if ( $windowWidth > 1279 ) {
		//         /* $.hook("sticky-target").stick_in_parent()
		//         .on("sticky_kit:stick", function(e) {
		//             // console.log("has stuck!", e.target);
		//         })
		//         .on("sticky_kit:bottom", function(e) {
		//             // console.log("has unstuck!", e.target);
		//         });     */
		//         $.hook("sticky-target").stick_in_parent({recalc_every: 1});
		//     }
		// });

		/**
		 * Load and initialize magnificPopup
		 */
		import('extensions/magnificpopup/jquery.magnific-popup').then(function() {
			themeFunctionality.sharedFunctions.initProductModal('x-product-layout-images__anchor');
		});

		/**
		 * Load and initialize product page carousels
		 */
		$(window).on('resize', function () {
			if ( $windowWidth < 960 ) {
				thumbnailLength = 3
			}
		});

		var $mainContainer = $.hook('x-product-layout-images__image-carousel'),
			mainOptions = {
				lazyLoad: 'ondemand',
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: $('.x-product-layout-images__prev'),
				nextArrow: $('.x-product-layout-images__next'),
				//asNavFor: '.x-product-layout-images__thumbnail-list',
				infinite: true,
				arrows: true
			};

		var $thumbnailContainer = $.hook('x-product-layout-images__thumbnail-list'),
			thumbnailOptions = {
			slidesToShow: 5,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			asNavFor: '.x-product-layout-images__image-carousel',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						infinite: true
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
						infinite: true
					}
				}
			]
		};

		var $carouselContainer = $.hook('product-carousel'),
			carouselOptions = {
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
				arrows: true,
				prevArrow:'<button type="button" class="x-flex-slider--prev slick-prev t-icon-arrow_carousel_prev" aria-label="Previous" role="button"></button>',
				nextArrow: '<button type="button" class="x-flex-slider--next slick-next t-icon-arrow_carousel_next" aria-label="Next" role="button"></button>',
				responsive: [
					{
						breakpoint: 960,
						settings: {
							centerMode: true,
							centerPadding: '40px',
							slidesToShow: 2
						}
					},
					{
						breakpoint: 480,
						settings: {
							centerMode: true,
							centerPadding: '20px',
							slidesToShow: 1
						}
					}
				]
			}

		themeFunctionality.productFunctions.initializeSlickSlider($carouselContainer, carouselOptions);

		if ( $('#thumbnails > li').length > thumbnailLength || $('#thumbnails > div').length > thumbnailLength ) {
			themeFunctionality.productFunctions.initializeSlickSlider($thumbnailContainer, thumbnailOptions);
		} else {
			// Give the slick-initalize class to reveal list
			$.hook('x-product-layout-images__thumbnail-list').addClass('active');
		}

		$.hook('x-product-layout-images__thumbnail-image').on('click', function(e){
			var slide_index = $(this).attr('data-slick-index');
			$.hook('x-product-layout-images__image-carousel').slick('slickGoTo', slide_index);
		});

		themeFunctionality.productFunctions.initializeSlickSlider($mainContainer,mainOptions);

		$.hook('x-product-layout-images__image-carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
			var prod_thumbs = $.hook('x-product-layout-images__thumbnail-list').hasClass('slick-initialized');

			if (prod_thumbs) {
				console.log('goto', currentSlide);
				$.hook('x-product-layout-images__thumbnail-list').slick('slickGoTo', currentSlide);
			} else {
				$.hook('x-product-layout-images__thumbnail-list').find('.x-product-layout-images__thumbnail-image').removeClass('slick-current');
				$.hook('x-product-layout-images__thumbnail-list').find('.x-product-layout-images__thumbnail-image').eq(currentSlide).addClass('slick-current');
			}

		});


		ImageMachine.prototype.oninitialize = function(data) {
			var self = this;

			if (data) {
				if (data[0] && data[0].image_data[1]) {
					var img = new Image();
					img.onload = function() {

						$('.x-product-layout-images__image-carousel.slick-initialized').slick('unslick');
						$('.x-product-layout-images__image-carousel').removeClass('slick-initialized').html('');

						$('.x-product-layout-images__thumbnail-list.slick-initialized').slick('unslick');
						$('.x-product-layout-images__thumbnail-list').removeClass('slick-initialized').html('');

						self.Initialize(data);
						themeFunctionality.productFunctions.initializeSlickSlider($thumbnailContainer, thumbnailOptions);
						themeFunctionality.productFunctions.initializeSlickSlider($mainContainer, mainOptions);
						themeFunctionality.sharedFunctions.initProductModal('x-product-layout-images__anchor');
						//themeFunctionality.sharedFunctions.initMiniModals();
					}
					img.src = data[0].image_data[1];
				} else {

					$('.x-product-layout-images__image-carousel.slick-initialized').slick('unslick');
					$('.x-product-layout-images__image-carousel').removeClass('slick-initialized').html('');

					$('.x-product-layout-images__thumbnail-list.slick-initialized').slick('unslick');
					$('.x-product-layout-images__thumbnail-list').removeClass('slick-initialized').html('');

					self.Initialize(data);
					themeFunctionality.productFunctions.initializeSlickSlider($thumbnailContainer, thumbnailOptions);
					themeFunctionality.productFunctions.initializeSlickSlider($mainContainer, mainOptions);
					themeFunctionality.sharedFunctions.initProductModal('x-product-layout-images__anchor');
					//themeFunctionality.sharedFunctions.initMiniModals();
				}
			}
		}

		if ( $(window).width() < 960 ) {
			$('.x-component--deck__wrap').removeClass('o-layout u-grids-2--m u-grids-3--w').addClass('x-flex-slider');
			$('.x-component--article__item, .x-component--video__item').removeClass('o-layout__item');
		}

		$('input[name="flex-tab"]').on('change', function(e){
			var $thisId = $(this).attr('id');
			if ( $(window).width() < 960 && $thisId === 'tab-resources' ) {
				$('.x-component--deck__wrap').slick({
					slidesToShow: 1.5,
					slidesToScroll: 1,
					infinite: false,
					arrows: false,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2.5
							}
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 1
							}
						}
					]
				});
			}
		});

		/**
		 * Load and initialize the qna extension
		 */
		import('extensions/qna/qna');

		/**
		 * Social Share
		 */
		themeFunctionality.sharedFunctions.productShareButtons();

		$.hook('toggle-options').on('click', function(e){
			$('.x-product-layout-purchase__attribute-hidden').toggleClass('u-hidden');

			$(this).toggleClass('active');

			if ( $(this).find('.c-button--text').text() === 'See More Choices' ) {
				$(this).find('.c-button--text').text('See Less Choices');
			} else {
				$(this).find('.c-button--text').text('See More Choices');
			}

			//$.hook("sticky-target").trigger('sticky_kit:recalc');
		});

		/**
		 * "kitprice" Customer Login Kit Price on Variant Change display
		 */
		if (mivaJS.Customer_Login == 'kitprice') {

			MivaEvents.SubscribeToEvent('variant_changed', function(product_data) {

				themeFunctionality.sharedFunctions.xVariantKitPriceChange(product_data);

			});

			themeFunctionality.sharedFunctions.xVariantKitPriceChange({
				product_code: mivaJS.Product_Code,
				variant_id: mivaJS.Default_Variant_ID
			});

		}


		// Affirm Helper Functions - Start
		function setObserverOnAffirm() {
			// Target
			var targetNode = document.getElementById("price-value");

			if (targetNode === null) return;

			// Set callback and return instance
			var observer = new MutationObserver(observerOnAffirmCallback);

			// Set Observer
			observer.observe(targetNode, {
				characterData: true, //Firefox, IE
				subtree: true, //Firefox, IE
				childList: true // Chrome
			});
		}

		// Only run depending on what type
		/**
		 * @param  {Mutation Record<Array>} mutationList
		 */
		function observerOnAffirmCallback(mutationList) {
			// Return target
			var targetNode = mutationList[0].target;

			// Only have one observer and one type execute function
			updateAffirmPricingOnChange(targetNode);
		}

		/**
		 * @param  {DOM Node} price_node
		 */
		function updateAffirmPricingOnChange(price_node) {
			// Default
			var productPriceContainer = price_node || document.getElementById('price-value');
			var affirmContainer = document.querySelector('#affirm-container > .affirm-as-low-as');
			var productPrice = '000';

			if (!affirmContainer) {
				return;
			}

			// Ensure we have our elements and the correct attribute
			if (!affirmContainer.dataset.hasOwnProperty('amount') || productPriceContainer === null) return;

			// Return price
			productPrice = productPriceContainer.textContent.replace(/[$,\.]/g, '');

			// Set data attribute
			affirmContainer.dataset.amount = productPrice;

			// Refresh affirm UI
			affirm.ui.refresh();
		}
		// Affirm Helper Functions - End

		// On Load
		setObserverOnAffirm();

	},
	jsPLST: function() {
	},
	jsSRCH: function() {

	},
	jsBASK: function() {
		themeFunctionality.sharedFunctions.xToggleDrawer();

		/**
		 * Load and initialize the shipping estimate extension
		 */
		import('extensions/shipping-estimate/shipping-estimate');

		/**
		 * Load and initialize the Quantify extension
		 */
		import('extensions/quantify/quantify');

		/**
		 * Load and initialize the Manage Quotes extension
		 */
		import('extensions/request-quotes/request_quote');

		$.hook('x-basket-kit__toggle').on('click', function(e) {
			$(this).parents('.c-table-responsive__cell').find('.x-basket-kit').toggleClass('u-hidden');
		});

		$('body').on('change', '.c-form-input__group', function() {
			var $current_selection = $(this).val().indexOf('yes'),
				toggle_element = $(this).parents('.c-form-list__item').next('.x-quotes-form__row___toggle').length;

			if ( $current_selection > -1 && toggle_element > 0) {
				$(this).parents('.c-form-list__item').next('.x-quotes-form__row___toggle').removeClass('u-hidden');
			} else if ( $current_selection == -1 && toggle_element > 0 ) {
				$(this).parents('.c-form-list__item').next('.x-quotes-form__row___toggle').addClass('u-hidden');
				$(this).parents('.c-form-list__item').next('.x-quotes-form__row___toggle').find('input').val('');
			}
		});
	},
	jsORDL: function() {
	},
	jsORDS: function() {
		themeFunctionality.sharedFunctions.xToggleDrawer();
	},
	jsOCST: function() {

		themeFunctionality.sharedFunctions.xToggleDrawer();
		themeFunctionality.sharedFunctions.redeemCoupon();
		//themeFunctionality.sharedFunctions.redeemGiftCertificate();

		// Simple Validation
/*        $.hook('c-form-list__submit').on('click', function(e){

			e.preventDefault();

			var isValid = false,
				$agreementInput = $('input[name="Terms_Agreement"]'),
				$placeOrderInput = $('input[name="PlaceOrderName"]');

			if ( $agreementInput.is(':checked') == false ) {
				$agreementInput.parent('label').addClass('has-error');
			} else {
				$agreementInput.parent('label').removeClass('has-error');
			}

			if ( $placeOrderInput.val().length > 0 ) {
				$placeOrderInput.prev('label').removeClass('has-error');
			} else {
				$placeOrderInput.prev('label').addClass('has-error');
			}

		});*/

	},
	jsOSEL: function() {
		import('extensions/basketfields/basketfields');
		themeFunctionality.sharedFunctions.xToggleDrawer();

		themeFunctionality.sharedFunctions.redeemCoupon();
		//themeFunctionality.sharedFunctions.redeemGiftCertificate();

		// Affirm Embed - Start
		var _affirm_config = {
			public_api_key: "VRM432K9OA5UUV84",
			/* Affirm Public API Key */
			script: "https://cdn1.affirm.com/js/v2/affirm.js",
			session_id: "sID"
		};

		(function(l, g, m, e, a, f, b) {
			var d, c = l[m] || {},
				h = document.createElement(f),
				n = document.getElementsByTagName(f)[0],
				k = function(a, b, c) {
					return function() {
						a[b]._.push([c, arguments])
					}
				};
			c[e] = k(c, e, "set");
			d = c[e];
			c[a] = {};
			c[a]._ = [];
			d._ = [];
			c[a][b] = k(c, a, b);
			a = 0;
			for (b = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < b.length; a++) d[b[a]] = k(c, e, b[a]);
			a = 0;
			for (b = ["get", "token", "url", "items"]; a < b.length; a++) d[b[a]] = function() {};
			h.async = !0;
			h.src = g[f];
			n.parentNode.insertBefore(h, n);
			delete g[f];
			d(g);
			l[m] = c
		})(window, _affirm_config, "affirm", "checkout", "ui", "script", "ready");
		// Affirm Embed - End
	},
	jsOPAY: function() {
		themeFunctionality.sharedFunctions.xToggleDrawer();
		themeFunctionality.sharedFunctions.redeemCoupon();
		//themeFunctionality.sharedFunctions.redeemGiftCertificate();
	},
	jsINVC: function() {
		themeFunctionality.sharedFunctions.xToggleDrawer();
	}
};

export {
	themeFunctionality
};
